import { Box, Typography } from "@mui/material";
import { useRecoilValue } from "recoil";
import { messagesState } from "../../../../recoil";
import Message from "./Message";

const MessageList = ({
    isShowingNewMessage
}: {
    isShowingNewMessage: boolean
}) => {

    const messages = useRecoilValue(messagesState);

    if (messages.length === 0 && !isShowingNewMessage) {
        return (
            <Box py={5}>
                <Typography align="center">No Messages To Show</Typography>
            </Box>
        )
    }

    return (
        <>
            {messages
                .map(n => (
                    <Message key={n.id} value={n} />
                ))
                .reverse()
            }
        </>
    )
};

export default MessageList;